import { getApp, getApps, initializeApp, type FirebaseApp } from "firebase/app";
import { connectAuthEmulator, getAuth, type Auth } from "firebase/auth";
import { connectFirestoreEmulator, getFirestore, type Firestore } from "firebase/firestore";
import { connectFunctionsEmulator, getFunctions, type Functions } from "firebase/functions";
import { readFirebaseClientSettings } from "@kajikajy/shared/firebase-web-config";

declare global {
  var __kajikajyFirebaseEmulatorsConnected: boolean | undefined;
}

export const firebaseClientSettings = readFirebaseClientSettings(import.meta.env, {
  devDefault: import.meta.env.DEV
});

export interface KajikajyFirebaseClient {
  readonly app: FirebaseApp;
  readonly auth: Auth;
  readonly db: Firestore;
  readonly functions: Functions;
}

export function getKajikajyFirebaseClient(): KajikajyFirebaseClient | null {
  if (!firebaseClientSettings.config) {
    return null;
  }

  const app = getApps().length > 0 ? getApp() : initializeApp(firebaseClientSettings.config);
  const auth = getAuth(app);
  const db = getFirestore(app);
  const functions = getFunctions(app, firebaseClientSettings.emulator.functionsRegion);

  if (firebaseClientSettings.useEmulators && !globalThis.__kajikajyFirebaseEmulatorsConnected) {
    connectAuthEmulator(
      auth,
      `http://${firebaseClientSettings.emulator.authHost}:${firebaseClientSettings.emulator.authPort}`,
      { disableWarnings: true }
    );
    connectFirestoreEmulator(
      db,
      firebaseClientSettings.emulator.firestoreHost,
      firebaseClientSettings.emulator.firestorePort
    );
    connectFunctionsEmulator(
      functions,
      firebaseClientSettings.emulator.functionsHost,
      firebaseClientSettings.emulator.functionsPort
    );
    globalThis.__kajikajyFirebaseEmulatorsConnected = true;
  }

  return { app, auth, db, functions };
}
